




























































import { EnterBreakNode, InputDocNode, ParagraphNode } from '@getaccept/editor-lib';
import { AvatarSize, IconSize, ParagraphSize } from '@getaccept/lib-ui';
import { Editor, EditorContent } from '@tiptap/vue-2';
import type { PropType, Ref } from '@vue/composition-api';
import { computed, defineComponent, onMounted, ref } from '@vue/composition-api';
import History from '@tiptap/extension-history';
import Text from '@tiptap/extension-text';
import { DateTime } from 'luxon';
import { DateHelper } from '../../helpers/date.helper';
import { t } from '../../helpers/translation.helper';
import type { CommentParticipantMetaData } from '../types/comment-participant-meta-data';

export default defineComponent({
  components: {
    EditorContent,
  },
  props: {
    createdAt: {
      type: Number,
      default: 0,
    },
    isGhost: {
      type: Boolean,
      default: false,
    },
    isRead: {
      type: Boolean,
      default: false,
    },
    isReply: {
      type: Boolean,
      default: false,
    },
    isResolvable: {
      type: Boolean,
      default: false,
    },
    createdByMetaData: {
      type: Object as PropType<CommentParticipantMetaData>,
      required: true,
    },
    text: {
      type: String,
      default: '',
    },
  },
  setup: props => {
    const editor: Ref<Editor | null> = ref(null);

    const showMessageOptions = ref(false);

    const localizedDate = computed(() => {
      const date = DateTime.fromMillis(props.createdAt);

      if (DateHelper.isToday(date)) {
        return t('Today').toString();
      }
      if (DateHelper.isYesterday(date)) {
        return t('Yesterday').toString();
      }

      return date.toLocaleString(DateTime.DATE_SHORT);
    });

    const localizedTime = computed(() => {
      const date = DateTime.fromMillis(props.createdAt);

      return date.toLocaleString(DateTime.TIME_SIMPLE);
    });

    onMounted(async () => {
      let content;

      // TODO: Delete all comments with plain text in DB, remove this try catch
      try {
        content = JSON.parse(props.text);
      } catch (e) {
        content = props.text;
      }

      editor.value = new Editor({
        content,
        editable: false,
        enablePasteRules: false,
        extensions: [InputDocNode, ParagraphNode, Text, History, EnterBreakNode],
      });
    });

    return {
      AvatarSize,
      editor,
      IconSize,
      localizedDate,
      localizedTime,
      ParagraphSize,
      showMessageOptions,
      t,
    };
  },
});
